<div class="wa-stack wa-gap-xl">
  @if (currentSurvey.hasValue()) {
    <div class="wa-heading-xl">Preferences for {{currentSurvey.value().name}}</div>
  } @else {
   <wa-callout variant="warning">
    <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
    <strong>No valid semester has been selected.</strong><br/>
     Please <a href="/home">return to the main page</a> to select a valid semester first.
  </wa-callout>
}

<wa-tab-group>
  <wa-tab panel="preferences">My Preferences</wa-tab>
  <wa-tab panel="assignments">My Assignments</wa-tab>

  <wa-tab-panel name="preferences">
    @if(currentSurvey.hasValue() && currentUser) {
    <app-preference-list
      [user]="currentUser"
      [survey]="currentSurvey.value()!">
    </app-preference-list>
    }
    </wa-tab-panel>

  <wa-tab-panel name="assignments">
    @if(currentSurvey.hasValue() && currentUser) {
    <app-survey-assignment
      [user]="currentUser"
      [survey]="currentSurvey.value()!">
    </app-survey-assignment>
    }
  </wa-tab-panel>

</wa-tab-group>
</div>




<!--   @if (user && user.isAdmin) {-->
<!--    <wa-tab-panel name="dashboard">-->
<!--      <app-survey-dashboard-->
<!--          [user]="user"-->
<!--          [survey]="survey"-->
<!--          (processingEvent)="this.processing = $event">-->
<!--        </app-survey-dashboard>-->
<!--    </wa-tab-panel>-->
<!--  }-->
